export default "__VITE_ASSET__5697c31d__"